// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/banner_templates" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdBannerTemplates } from "./constants";
import type { EngagementAppGroupIdBannerTemplatesParams, EngagementAppGroupIdBannerTemplatesResult } from "./types";
import { isEngagementAppGroupIdBannerTemplatesResult } from "./validators";

export const getDataTableEngagementAppGroupIdBannerTemplates = reactQueryTableFetcherAdapter(
  engagementAppGroupIdBannerTemplates,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query = {},
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
    }: EngagementAppGroupIdBannerTemplatesParams
  ): Promise<EngagementAppGroupIdBannerTemplatesResult> => {
    return fetch(
      `/engagement/${appGroupId}/banner_templates`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  },
  isEngagementAppGroupIdBannerTemplatesResult
);
